
export default {
  'navbar.lang': 'Afrikaans',
  'menu.home': 'Tuis',
  'menu.dashboard': 'Dashbord',
  'menu.profile': 'Profiel',
  'menu.settings': 'Instellings',

  'user.login.title': 'Skandering suksesvol!',
  'user.login.subtitle': 'Verskaf u besonderhede om voort te gaan',
  'user.login.username': 'Gebruikersnaam of e-pos',
  'user.login.password': 'Wagwoord',
  'user.login.forgot': 'Wagwoord vergeet?',
  'user.login.button': 'Teken in',

  'user.register.title': 'Skep nuwe rekening',
  'user.register.button': 'Teken aan',
  'user.register.success': 'Rekening geskep. Kontroleer e-pos om te bevestig.',

  'user.login.welcome.subheading': "Welkom in 'n wêreld waar vryheid unieke lewe ontmoet! Skan. Verdien punte. Leef vry. Leef uniek",
  'user.login.description': 'Jy het ons QR-kode suksesvol geskandeer. Meld aan of registreer hieronder om belonings en punte te eis',
  'user.login.signin.title': 'Teken in',
  'user.login.signin.sub': 'Voer asseblief jou telefoonnommer in; ons sal \'n verifikasie kode stuur',
  'user.login.phoneNumberLabel': 'Telefoonnommer',
  'user.login.enterPhonePlaceholder': 'Voer telefoonnommer in',
  'user.login.invalidPhone': 'Ongeldige telefoonnommer',
  'user.login.phoneRequired': 'Telefoonnommer is vereis',
  'user.login.signingIn': 'Teken in...',
  'user.login.continue': 'Gaan voort',
  'user.login.noAccount': 'Het jy nie \'n rekening nie?',
  'user.login.signup': 'Teken aan',
  'user.login.footerCopyright': 'Kopiereg © {year}. Aangedryf deur Exceptional Brands',

  'user.register.welcome': 'Welkom!',
  'user.register': 'Teken aan om jou belonings te eis',
  'user.register.description': 'Voltooi jou besonderhede hieronder om punte te verdien, belonings te ontsluit en prys te wen',
  'user.register.phone.label': 'Telefoonnommer',
  'user.register.phone.placeholder': 'Voer telefoonnommer in',
  'user.register.phone.required': 'Telefoonnommer is vereis',
  'user.register.phone.invalid': 'Ongeldige telefoonnommer',
  'user.register.name.label': 'Jou Naam',
  'user.register.name.placeholder': 'bv. Mark',
  'user.register.name.required': 'Naam is vereis',
  'user.register.ageGroup.label': 'Ouderdomsgroep (Opsioneel)',
  'user.register.gender.label': 'Geslag (Opsioneel)',
  'user.register.gender.male': 'Man',
  'user.register.gender.female': 'Vrou',
  'user.register.terms.agreement': 'Deur voort te gaan, stem jy in tot ons {termsLink} en {privacyLink}.',
  'user.register.terms.termsOfService': 'Diensvoorwaardes',
  'user.register.terms.privacyPolicy': 'Privaatheidsbeleid',
  'user.register.creating': 'Skep profiel…',
  'user.register.create': 'Skep profiel',
  'user.register.alreadyAccount': 'Het jy reeds \'n rekening?',
  'user.register.signin': 'Teken in',
  'user.register.footer.copyright': 'Kopiereg © {year}. Aangedryf deur Exceptional Brands',

  "user.welcome.welcome": "Welkom!",
  "user.welcome.welcome_name": "Welkom {name}!",
  'user.welcome.points_earned': 'Geluk, jy het ontvang',
  'user.welcome.thank_you': 'Dankie vir die registrasie!',
  'user.welcome.earn_more_points': 'Om meer punte te kry, beoordeel meer produkte wat jy by ons gekoop het.',
  'user.welcome.continue': 'Gaan voort',
  'user.welcome.logging_in': 'Aanmeld...',
  "user.welcome.welcome_reward": "Welkomstbeloning",
  "user.welcome.points_label": "punte!",
  "user.welcome.loggingIn": "Aanmeld...",

  "product.button.continue": "Gaan voort",
  "product.button.selectToContinue": "Kies \'n produk om voort te gaan",

  'scansuccess.review.heading': 'Hoe sou u hierdie produk beoordeel?',
  'scansuccess.review.continue': 'Handelaar kode (Opsioneel)',
  'scansuccess.review.select-product': 'Voeg ' + "handelaarskode by om meer punte te verdien",
  'scansuccess.review.review-products': 'Dien resensie in',

  "product.retailerCode.label": "Handelaar kode",
  "product.retailerCode.requiredLabel": "Vereis",
  "product.retailerCode.optionalLabel": "Opsioneel",
  "product.retailerCode.placeholder": "Voer handelaar kode in",
  "product.retailerCode.aria": "Handelaar kode",
  "product.retailerCode.hintRequired": "Handelaar kode is nodig om hierdie resensie te stuur",
  "product.retailerCode.hintOptional": "Voeg 'n handelaar kode by om meer punte te verdien",
  "product.retailerCode.error.required": "Handelaar kode is vereis",
  "product.retailerCode.error.invalid": "Ongeldige handelaar kode",

  "profile.title": "My profiel",
  "profile.tier.member": "Lid",
  "profile.points": "Punte",
  "profile.pointsEarned": "Punte ontvang",
  'scansuccess.continue': 'Gaan voort',
  "profile.completeTitle": "Voltooi jou profiel",
  "profile.completeSubtitle": "Verdien {points} bonuspunte!",
  "profile.completedTitle": "Profiel voltooi! ✓",
  "profile.completedSubtitle": "Jy het al die {points} bonuspunte verdien!",
  "profile.completeButton": "Voltooi Profiel (+{points} pt)",
  "profile.redeem": "✓ Profiel voltooi",
  "product.review.placeholder": "Skryf 'n resensie... (een karakter is genoeg)",
  "product.review.ariaLabel": "Skryf 'n resensie",
  "profile.field.phoneNo.label": "Telefoonnommer",
  "profile.field.phoneNo.add": "Voeg jou nommer by",
  "profile.field.email.label": "E-posadres",
  "profile.field.email.add": "Voeg jou e-pos by",
  "profile.field.countryCode.label": "Ligging",
  "profile.field.countryCode.add": "Voeg jou ligging by",
  "profile.field.name.label": "Naam",
  "profile.field.name.add": "Voeg jou naam by",
  "profile.field.dateOfBirth.label": "Geboortedatum",
  "profile.field.dateOfBirth.add": "Voeg jou geboortedatum by",
  "profile.pointsPlus": "+{points} pt",
  "profile.modal.updateTitle": "Werk {field} by",
  "profile.modal.completeTitle": "Voltooi jou profiel",
  "profile.modal.update": "Werk by",
  "profile.modal.complete": "Voltooi profiel",
  "profile.modal.cancel": "Kanselleer",
  "profile.completedBadge": "Jy het {points} punte ontvang",
  "profile.progressPercent": "{percent}% Voltooi",
  "profile.progressRemaining": "{percent}% oor",
  'scansuccess.congratulations.heading': 'Geluk!',
  'scansuccess.congratulations.continue': 'Jy het ontvang',
  'scansuccess.congratulations.select-product': 'Dankie vir jou resensie',
  'scansuccess.congratulations.review-products': 'Om meer punte te verdien, beoordeel meer produkte wat jy by ons gekoop het',
  'scansuccess.congratulations.create': 'Gaan na Dashbord',
  'user.brand-product-review.title': 'Kies handelsmerk en produk om voort te gaan',
  'user.brand-product-review.continue': 'Gaan voort',
  'user.brand-product-review.select-product': 'Kies ' + "n produk om voort te gaan",
  'user.brand-product-review.review-products': 'Beoordeel ons produkte om punte te kry',
  'user.brand-product-review.rate-product': 'Beoordeel asseblief ten minste een produk hierbo om voort te gaan',
  'user.brand-product-review.footer': 'Kopiereg © {year}. Aangedryf deur Exceptional Brands',
  'scansuccess.title': 'Scan resultate',
  'scansuccess.scan.message': 'Dankie — jou skandering was suksesvol.',
  'scansuccess.scan.instructions': 'Jy kan punte eis, ' + "n resensie skryf of vir aanbiedings registreer.",
  'scansuccess.signup.title': 'Teken in om belonings te eis',
  'scansuccess.signup.button': 'Teken aan',
  'scansuccess.welcomepoints.title': 'Welkomstpunte',
  'scansuccess.welcomepoints.pointsLabel': 'Punte toegekend',
  'scansuccess.brandproductreview.title': 'Handelsmerk en produk resensie',
  'scansuccess.brandproductreview.leaveReview': 'Laat ' + "n resensie",
  'scansuccess.productreview.title': 'Produkresensie',
  'scansuccess.productreview.submit': 'Dien resensie in',
  'scansuccess.congratulations.title': 'Geluk!',
  'scansuccess.congratulations.message': 'Jy het punte verdien — kyk op jou dashbord om dit te eis.',
  'scansuccess.noAccount': 'Het jy nie \'n rekening nie?',
  'scansuccess.signup': 'Teken aan',

  "user.register.createProfile": "Skep rekening",
  "user.register.creatingProfile": "Skep rekening...",
  "user.register.termsOfService": "Diensvoorwaardes",
  "user.register.privacyPolicy": "Privaatheidsbeleid",

  'dashboard.multiplescans.title': 'Meervoudige skande',
  'dashboard.multiplescans.instructions': 'Hanter meervoudige skande en belonings saam.',
  'dashboard.title': 'Welkom!',
  'dashboard.balance': 'Jou balans',
  'dashboard.balance-sub': 'punte',
  'dashboard.redeem': 'Eis',
  'dashboard.stat': 'Totale skande',
  'dashboard.label': 'Belonings gewen',
  'dashboard.redeem.title': 'Eis jou punte',
  'dashboard.redeem.success': 'Eis belonings',
  'dashboard.primary-sub': 'Gebruik jou punte om belonings te ontsluit',
  'dashboard.secondary-btn': 'Skaan weer',
  'dashboard.secondary': 'Verwys ' + "n vriend",
  'dashboard.loyalty': 'Lojaliteit vlakke',
  'dashboard.5000pts': '5000 punte',
  'dashboard.100pts': '100 punte tot Platinum',
  'dashboard.almost-there': 'Byna daar!',
  'dashboard.recent': 'Onlangse aktiwiteit',
  'settings.title': 'Instellings',

  'settings.balance': 'Goud lid',
  'settings.balance-sub': 'Punte',
  'settings.redeem': 'Rekening',
  'settings.stat': 'Wysig profiel',
  'settings.label': 'Werk persoonlike inligting op',
  'settings.redeem.title': 'Voorkeure',
  'settings.redeem.success': 'Kennisgewings',
  'settings.primary-sub': 'Push & e-pos voorkeure',
  'settings.secondary-btn': 'Taal',
  'settings.secondary': 'Afrikaans',
  'settings.loyalty': 'Hulp & Voorwaardes',
  'settings.5000pts': 'Hulp & Ondersteuning',
  'settings.100pts': 'Vrae, kontak ons',
  'settings.almost-there': 'Terme en toestande',
  'settings.recent': 'Regsinligting',
  'settings.points': 'Privaatheidsbeleid',
  'settings.data': 'Data beskerming inligting',
  'settings.sign': 'Teken uit',

  'profile.balance': '% Voltooi',
  'profile.balance-sub': '% oor',
  'profile.stat': 'Profielinligting',
  'profile.label': 'pt',
  'profile.redeem.title': 'Skakel sosiale media',
  'profile.redeem.success': 'Verdien punte vir elke skakeling!',
  'profile.primary-sub': 'Facebook',
  'profile.secondary-btn': '+20 pt',
  'profile.secondary': 'Instagram',
  'profile.loyalty': '+20 pt',
  'profile.5000pts': 'X (Twitter)',
  'profile.100pts': '+20 pt',
  'profile.almost-there': 'Skakel jou sosiale media vir 20 punt bonus!',
  'profile.recent': 'Vul die volgende velde in om jou profiel te voltooi en te verdien ',
 

  "country.KE": "Kenya",
  "country.ZW": "Zimbabwe",
  "country.ZA": "Suid-Afrika",
  "country.BJ": "Benin",
  "country.AE": "Verenigde Arabiese Emirate",

  "dashboard.welcome": "Welkom!",
  "dashboard.user.unknown": "Gebruiker",
  "dashboard.balanceLabel": "Jou balans",
  "dashboard.coinsAlt": "munte",
  "dashboard.pointsLabel": "punte",
  "dashboard.redeemBtn": "Gebruik punte",
  "dashboard.totalScans": "Totale skande",
  "dashboard.rewardsWon": "Belonings gewen",
  "dashboard.redeemTitle": "Eis jou punte",
  "dashboard.redeemRewards": "Eis belonings",
  "dashboard.redeemSub": "Gebruik jou punte om belonings te ontsluit",
  "dashboard.reviewProducts": "Beoordeel produkte",
  "dashboard.referFriend": "Verwys vriend",
  "dashboard.tiersTitle": "Lojaliteit vlakke",
  "dashboard.tier.default": "Member",
  "dashboard.tierTarget": "{max} pts",
  "dashboard.tierRemaining": "{points} to next tier",
  "dashboard.almostThere": "Byna daar!",
  "dashboard.recentActivityTitle": "Onlangse aktiwiteit",
  "dashboard.share.title": "Sluit aan by Exceptional Brands",
  "dashboard.share.text": "Skakel aan by Exceptional Brands! Verdien punte deur produkte te skandeer en kry wonderlike belonings. Gebruik my verwysingskakel: {url}",
  "dashboard.shareModalTitle": "Deel met vriende",
  "dashboard.shareModalDesc": "Deel Exceptional Brands met jou vriende en verdien bonuspunte wanneer hulle aansluit!",
  "dashboard.platform.facebook": "Facebook",
  "dashboard.platform.instagram": "Instagram",
  "dashboard.platform.twitter": "Twitter",
  "dashboard.platform.whatsapp": "WhatsApp",
  "dashboard.shareLinkLabel": "Jou verwysingskakel:",
  "dashboard.share.instagramCopied": "Skakel gekopieer na knipbord - plak in Instagram",
  "dashboard.footerCopyright": "Kopiereg © {year}. Aangedryf deur Exceptional Brands",
  "dashboard.aria.welcome": "Welkomst paneel",
  "dashboard.aria.notifications": "Kennisgewings",
  "dashboard.aria.settings": "Instellings",
  'dashboard.redeem.points': 'Eis jou punte',
  'dashboard.redeem.subtitle': 'Gebruik jou punte om belonings te ontsluit',
  'dashboard.redeem.sub': 'punte',
  'dashboard.redeem.progress': 'Vordering na Platinum',
  'dashboard.redeem.stat': 'Beskikbare belonings',
  'dashboard.redeem.label': 'Eis',
  'dashboard.redeem.need': 'Benodigd',
  'dashboard.redeem.prize': 'Prys aflaai',
  'dashboard.redeem.scan': 'Hoe meer jy skandeer hoe hoër is jou kans om iets oulik te wen',
  'dashboard.redeem.recent': 'Onlangse aktiwiteit',
  'global.back': 'Terug',
  'global.next': 'Volgende',
  'global.search.placeholder': 'Soek...',
  'validation.required': 'Hierdie veld is verpligtend',
  'error.404.title': 'Bladsy nie gevind nie',
  'error.404.subTitle': 'Sorry, ons kan nie die bladsy vind waarna jy soek nie.',
};
